var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupBlackSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "70a4a",
    d: "M725.04 76.652a3.629 3.629 0 0 1 1.679-5.507 2.54 2.54 0 0 0-1.992-.965 2.542 2.542 0 1 0-1.487 4.607A4.733 4.733 0 0 0 720 79.27c0 .201.163.364.364.364h1.705a6.215 6.215 0 0 1 2.97-2.983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "70a4b",
    d: "M729.643 76.946a2.907 2.907 0 0 0-1.645-5.306 2.907 2.907 0 1 0-1.645 5.306c-2.373.635-4.046 2.636-4.173 5.222a.363.363 0 0 0 .364.381h10.909a.365.365 0 0 0 .363-.381c-.127-2.586-1.8-4.587-4.173-5.222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "70a4c",
    d: "M732.759 74.787a2.542 2.542 0 1 0-3.479-3.642 3.64 3.64 0 0 1 2.355 3.399c0 .765-.242 1.5-.676 2.108a6.215 6.215 0 0 1 2.97 2.983h1.706a.363.363 0 0 0 .364-.364 4.733 4.733 0 0 0-3.24-4.484"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-720 -70)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#70a4a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#70a4b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#70a4c"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupBlackSmall);
export default __webpack_public_path__ + "static/media/group-black-small.5132edd4c5dbd39245ddc565a5e73837.svg";
export { ForwardRef as ReactComponent };